import { requestPasswordReset } from "../auth_store.js";
import { authLayout, field, btnPrimary, alertBox, bindForm } from "./auth_shell.js";
import { navigate } from "../router.js";
import { t } from "../i18n.js";

export function renderForgotPassword(root) {
  root.innerHTML = authLayout({
    title: t("Reset password"),
    subtitle: t("Enter your email and we'll send reset instructions."),
    childrenHtml: `
      <div id="forgot-alert"></div>
      <form class="portal-form" novalidate>
        ${field({ id: "email", label: t("Email"), type: "email", placeholder: "you@studio.com", autocomplete: "email" })}
        ${btnPrimary(t("Send reset link"), { type: "submit" })}
      </form>
    `,
    footerHtml: `<a class="portal-link" href="#/login">${t("← Back to sign in")}</a>`,
  });

  bindForm(root, (values) => {
    const alertEl = root.querySelector("#forgot-alert");
    const res = requestPasswordReset(values.email);
    if (!res.ok) {
      alertEl.innerHTML = alertBox(t(res.error ?? "Something went wrong."));
      return;
    }
    if (res.token) {
      navigate(`/reset-password?token=${encodeURIComponent(res.token)}`, true);
    } else {
      root.innerHTML = authLayout({
        title: t("Check your email"),
        subtitle: t("If an account exists for that address, you'll receive a reset link shortly."),
        childrenHtml: `
          <div class="portal-alert portal-alert--success">${t("Request received. For this demo, use the link if your account exists.")}</div>
          ${btnPrimary(t("Back to sign in"), { id: "back-login" })}
        `,
        footerHtml: "",
      });
      root.querySelector("#back-login")?.addEventListener("click", () => navigate("/login", true));
    }
  });
}
